import { UPDATE_IS_QUEUE_TASK } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function updateIsQueueTask(isQueueTask) {
  return callingAPIMethodWithQueue(UPDATE_IS_QUEUE_TASK, {
    isQueueTask
  });
}